import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './BranchCard.styles';
const BranchCard = (props) => {
    const content = (React.createElement(React.Fragment, null,
        React.createElement("span", null,
            React.createElement(S.Title, null, props.title),
            React.createElement(S.Number, { href: `tel:${props.number.url}` }, props.number.text)),
        React.createElement(S.Section, null,
            React.createElement(S.Icon, null, getSystemIcon(SystemIcon.Location)),
            React.createElement("div", null, props.address.map((line, i) => (React.createElement("p", { key: `address-${i}` }, line))))),
        React.createElement(S.Section, null,
            React.createElement(S.Icon, null, getSystemIcon(SystemIcon.Clock)),
            React.createElement(S.OpeningHours, null, props.openingHours.map((day) => (React.createElement("tr", { key: `oh-${day[0]}` },
                React.createElement("td", null, day[0]),
                React.createElement("td", null, day[1])))))),
        props.ctas && props.ctas.length > 0 && (React.createElement(S.CtaWrapper, null, props.ctas.map((cta, i) => (React.createElement(LinkButton, { buttonType: i % 2 === 0 ? 'tertiary' : 'default', key: `${props.title}-cta-${i}`, href: cta.url, target: cta.target, icon: cta.icon }, cta.text)))))));
    return (React.createElement(S.Container, null,
        content,
        props.cardUrl && (React.createElement(S.CardLink, { href: props.cardUrl, "aria-label": `View details for ${props.title}` }))));
};
export default BranchCard;
